var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finding)?_c('v-container',{staticClass:"px-6 mt-0",attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":"","no-gutters":""}},[_c('v-col',{},[_c('Finding',{attrs:{"finding":_vm.finding}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }